// extracted by mini-css-extract-plugin
module.exports = {"link":"link--erwIfAr7xKQS2e0HuJaF"};